module.exports = "/images/ebef518b06dcfc1f95bcf5ca9c205f90.svg";